import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2, CheckCircle } from 'lucide-react';
import api from '@/lib/api';

const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_a3709e67-7648-4bcb-a123-219697b944ef/artifacts/aqwsfdgh_Martin_Aagaard_-_Kystlandskap_-_IMG_9313.jpg';

export default function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/contact', { name, email, message });
      setSubmitted(true);
      toast.success('Message sent');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative" data-testid="contact-page">
      {/* Background */}
      <div
        className="absolute inset-0 bg-center bg-cover opacity-30"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      />
      <div className="absolute inset-0 bg-[var(--cream)]/80" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header */}
        <header className="p-6">
          <Link to="/" className="text-lg text-[var(--navy-800)] font-light tracking-widest">
            COASTWISE TRADE
          </Link>
        </header>

        {/* Form */}
        <div className="flex-1 flex items-center justify-center px-6 py-8">
          <div className="w-full max-w-sm">
            {submitted ? (
              <div className="text-center">
                <CheckCircle className="h-16 w-16 text-emerald-600 mx-auto mb-4" />
                <h1 className="text-2xl font-semibold text-[var(--navy-800)] mb-4">
                  Message Sent
                </h1>
                <p className="text-[var(--muted-foreground)] mb-8">
                  We have received your message.
                </p>
                <Link to="/" className="btn-big inline-block">
                  Return
                </Link>
              </div>
            ) : (
              <>
                <h1 className="text-2xl font-semibold text-[var(--navy-800)] text-center mb-8">
                  Send a Message
                </h1>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-[var(--navy-800)] mb-2">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="input-field"
                      placeholder="Your name"
                      required
                      data-testid="contact-name-input"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[var(--navy-800)] mb-2">Email</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="input-field"
                      placeholder="you@example.com"
                      required
                      data-testid="contact-email-input"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[var(--navy-800)] mb-2">Message</label>
                    <textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      className="input-field min-h-[120px] resize-none"
                      placeholder="Your message"
                      required
                      data-testid="contact-message-input"
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn-big btn-big-primary flex items-center justify-center"
                    disabled={loading}
                    data-testid="contact-submit-button"
                  >
                    {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Send'}
                  </button>
                </form>

                <p className="mt-6 text-center text-sm text-[var(--muted-foreground)]">
                  <Link to="/enter" className="text-[var(--navy-800)] font-medium hover:underline">
                    ← Back
                  </Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
